module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/155-israel-70404cc9c09d88d397e8dbd277b6cfec.svg";